import React from 'react';
import { Checkbox } from '@tencent/tea-component';
import { BuyCheckboxGroup } from './BuyCheckboxGroup';
export function BuyCheckbox(_a) {
    var defaultValue = _a.defaultValue, value = _a.value, onChange = _a.onChange, display = _a.display, tooltip = _a.tooltip, onClick = _a.onClick, children = _a.children;
    return (React.createElement(Checkbox, { defaultValue: defaultValue, value: value, onChange: onChange, display: display, tooltip: tooltip, onClick: onClick }, children));
}
BuyCheckbox.Group = BuyCheckboxGroup;
//# sourceMappingURL=BuyCheckbox.js.map